import { api, ApiResponse } from './api';

export interface Workspace {
  id: string;
  uuid: string;
  name: string;
  slug: string;
  description?: string;
  avatar?: string;
  owner_id: string;
  settings?: Record<string, any>;
  theme?: Record<string, any>;
  is_public: boolean;
  custom_domain?: string;
  ssl_enabled: boolean;
  status: string;
  role?: string;
  is_owner?: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateWorkspaceData {
  name: string;
  description?: string;
  is_public?: boolean;
}

export interface UpdateWorkspaceData {
  name?: string;
  description?: string;
  is_public?: boolean;
  settings?: Record<string, any>;
  theme?: Record<string, any>;
}

export const workspaceApi = {
  getAll: async (): Promise<Workspace[]> => {
    const response = await api.get<ApiResponse<Workspace[]>>('/api/v1/workspaces');
    return response.data.data || [];
  },

  getById: async (id: string): Promise<Workspace> => {
    const response = await api.get<ApiResponse<Workspace>>(`/api/v1/workspaces/${id}`);
    return response.data.data!;
  },

  create: async (data: CreateWorkspaceData): Promise<Workspace> => {
    const response = await api.post<ApiResponse<Workspace>>('/api/v1/workspaces', data);
    return response.data.data!;
  },

  update: async (id: string, data: UpdateWorkspaceData): Promise<Workspace> => {
    const response = await api.patch<ApiResponse<Workspace>>(`/api/v1/workspaces/${id}`, data);
    return response.data.data!;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/api/v1/workspaces/${id}`);
  },
};
